<template>
    <div id="aboutQDS">
        <Headers :headersText='headersText'></Headers>

        <img src="../../assets/images/img_77.png" alt="" id="QDSIcon">
        <div class="abouts">钱大师是一款让您的无聊时间变得有价值的应用软件，通过完成各类简单易操作的小任务，您就可以获得奖励并且可在应用内提现至微信或者支付宝，收取徒弟您还可以得到惊人的收益</div>
        <img src="../../assets/images/business_wx_new.jpg" alt="" id="erweima">
        <div class="otherText">
            <span>钱大师安卓官方网站</span>
            <!-- <span>商务合作</span> -->
        </div>
        <div class="WebsiteText">我们的官网</div>
        <div class="website">http://www.moneyds.cn/</div>
    </div>
</template>

<script>
    import Headers from '../../components/headers.vue'
    export default {
        components:{
            Headers
        },
        data() {
            return {
                headersText:'关于钱大师'
            }
        },
        methods: {
            
        },
    }
</script>

<style lang="less" scoped>
    #aboutQDS{
        width: 100%;
        height: 100%;
        background: #FFFFFF;
        display: flex;
        flex-direction: column;
        align-items: center;
        #QDSIcon{
            width: 60px;
            height: 60px;
            margin-top: 35px;
        }
        .abouts{
            width: 335px;
            height: 108px;
            font-size: 13px;
            color: #151515;
            margin: 30px 0 50px;
            line-height: 18px;
        }
        #erweima{
            width: 80px;
            height: 80px;
            margin-bottom: 12px;
        }
        .otherText{
            margin-bottom: 50px;
            display: flex;
            flex-direction: column;
            span{
                font-size: 13px;
                color: #151515;
                line-height: 18px;
            }
        }
        .WebsiteText{
            color: #666666;
            font-size: 13px;
        }
        .website{
            color: #666666;
            font-size: 13px;
            padding: 7px 0 20px;
            text-decoration: underline;
        }
    }
</style>